import React from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { Theme } from 'swipeclock-frontend';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { subYears } from 'date-fns';
import PropTypes from 'prop-types';

export default function SwipeclockTheme({ children }) {
  return (
    <LocalizationProvider dateAdapter={ModifiedAdapterDateFns}>
      <Theme provider={ThemeProvider} enableLogging={false}>
        {children}
      </Theme>
    </LocalizationProvider>
  );
}

SwipeclockTheme.propTypes = {
  children: PropTypes.node,
};

export function ModifiedAdapterDateFns(options) {
  const adapter = new AdapterDateFns(options);
  return {
    ...adapter,
    getYearRange(start, end) {
      const startDate = adapter.endOfYear(end);
      const endDate = adapter.startOfYear(start);
      const years = [];

      let current = startDate;
      while (adapter.isAfter(current, endDate)) {
        years.push(current);
        current = subYears(current, 1);
      }

      return years;
    },
  };
}
